import { useEffect, useState } from 'react';
import { getData } from '../../../../utils/api'
import '../GdjyDetail/index'
import { getApi } from "../../../../utils/getApi";

export const GdjyDetailTwo = ({ activePage, setActivePage }) => {

    const [dataSource, setDataSource] = useState({});
    const [status, setStatus] = useState(true);
    const [path, setPath] = useState('');

    useEffect(() => {
        setPath(getApi())
        const getList = async () => {
            const res = await getData('/api/user/zhengshu', 'post')
            if (res.data.code == 1) {
                setDataSource(res.data.data[0]);
            }
        }
        if (window.location.search.length > 2) {
            setStatus(false)
        }
        getList()
    }, [])

    const formatDateString = (dateStr) => {

        // 检查输入是否为 null 或 undefined
        if (dateStr == null) {
            return dateStr; // 或返回默认值，如空字符串 ''
        }

        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
            return dateStr.replace(/(\d{4})-(\d{2})-(\d{2})/, '$1年$2月$3日');
        }
        return dateStr;
    }
    
    const bank = async () => {
        window.history.go(-1);
    }
    return (
        <div>
            <div className="white-header van-nav-bar van-hairline--bottom" style={{ zIndex: '1', background: '#fff' }}>
                <div className="van-nav-bar__left" >
                    <i className="van-icon van-icon-arrow-left van-nav-bar__arrow" style={{ color: '#333' }} onClick={bank}>


                    </i>


                </div>
                <div className="van-ellipsis van-nav-bar__title" style={{ color: '#333' }}>高等学历

                </div>
                <div className="van-nav-bar__right">


                </div>


            </div>

            <div className="padding16 xj-index"><div className="top-card xl-top-card"><div className="van-row"><div className="van-col van-col--5"><div className="img-div">
                <img src={`${path}${status ? dataSource.avatar : dataSource.sec_avatar}`} />
            </div>
            </div> <div className="van-col van-col--19"><h5 className="namtFamily">{dataSource.username}
            </h5> <p className="namtFamily">    <span>{dataSource.gender == 0 ? '女' : '男'}</span>&emsp;
                        <span>{dataSource.birthday}</span>
                    </p>
                </div>
            </div>
                <br />
                <div className="top-bottom-img xj-detail-img">
                    <p className='school'>
                        <span className='school-name'>{status ? dataSource.school_name : dataSource.sec_school_name}</span>
                        <span className='xueli-level1' style={{ background: '#2b77c7' }}>{status ? dataSource.xueli_level : dataSource.sec_xueli_level}</span>
                    </p>
                    <p className='zhuanye'>
                        <span>{status ? dataSource.zhuanye : dataSource.sec_zhuanye} &nbsp; | &nbsp; </span>
                        <span>{status ? dataSource.xingshi : dataSource.sec_xingshi}</span>
                    </p>

                </div>
            </div>

                <div className="xj-c">
                    <div><div className='l-text'>入学日期</div> <div>{status ? formatDateString(dataSource.enrollment_time) : formatDateString(dataSource.sec_enrollment_time)}</div></div>
                    <div><div className='l-text'>毕（结）业日期</div> <div>{status ? formatDateString(dataSource.graduation_time) : formatDateString(dataSource.sec_graduation_time)}</div></div>
                    <div><div className='l-text'>学历类别</div> <div>{status ? dataSource.leibie : dataSource.sec_leibie}</div></div>
                    <div><div className='l-text'>学制</div> <div>{status ? dataSource.xuezhi : dataSource.sec_xuezhi}</div></div>
                    <div><div className='l-text'>毕（结）业</div> <div>{status ? dataSource.is_biye == 0 ? '结业' : '毕业' : dataSource.sec_is_biye == 0 ? '结业' : '毕业'}</div></div>
                    <div><div className='l-text'>校（院）长姓名</div> <div>{status ? dataSource.rector : dataSource.sec_rector}</div></div>
                    <div><div className='l-text'>证书编号</div> <div>{status ? dataSource.certificate_number : dataSource.sec_certificate_number}</div></div>

                </div>


                <div className="van-row"><div className="van-col van-col--24"><a>

                    <button className="my-btn van-button van-button--primary van-button--normal" onClick={() => {
                        window.localStorage.setItem('type', 'xl'); 
                        if (status) {
                            window.localStorage.removeItem('status');

                        } else {
                            window.localStorage.setItem('status', 'twoxj');
                        }
						// 获取当前时间并添加一个月
						const now = new Date();
						now.setMonth(now.getMonth() + 1);
						
						// 格式化为 YYYY-MM-DD
						const year = now.getFullYear();
						const month = String(now.getMonth() + 1).padStart(2, '0');
						const day = String(now.getDate()).padStart(2, '0');
						const futureDate = `${year}-${month}-${day}`;
						
						window.localStorage.setItem('expiryDate', futureDate);
						window.location.href = '/gdjy/ReportIndex'

                    }}><span className="van-button__text">查看验证报告
                        </span>
                    </button>
                </a>
                </div>
                </div>
            </div>





        </div >
    )
};